import { render, staticRenderFns } from "./stockCount.vue?vue&type=template&id=3471ff56&scoped=true&"
import script from "./stockCount.vue?vue&type=script&lang=js&"
export * from "./stockCount.vue?vue&type=script&lang=js&"
import style0 from "./stockCount.vue?vue&type=style&index=0&id=3471ff56&prod&scoped=true&lang=css&"
import style1 from "./stockCount.vue?vue&type=style&index=1&id=3471ff56&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3471ff56",
  null
  
)

export default component.exports